import Vue from "vue";
import Router from "vue-router";
import PageNotFound from "@/components/Shared/PageNotFound/PageNotFound";
import Home from "@/components/subroute/Home/Home.vue";
import About from "@/components/subroute/About/About.vue";
import OurTeam from "./components/subroute/OurTeam/OurTeam";
import JoinNow from "./components/subroute/JoinNow/JoinNow";
import Contact from "./components/subroute/contact/contact";
import OurJourney from "./components/subroute/OurJourney/OurJourney";
import Career from "./components/subroute/Career/Career";
import Explore from "./components/subroute/Explore/Explore";
import Partners from "./components/subroute/Partners/Partners";
import CustomerGrievance from "./components/subroute/Others/CustomerGrievance/CustomerGrievance";
import FAQ from "./components/subroute/Others/FAQ/FAQ";
import PrivacyPolicy from "./components/subroute/Others/PrivacyPolicy/PrivacyPolicy";
import TNC from "./components/subroute/Others/TNC/TNC";
import SOC from "./components/subroute/Others/SOC/SOC";
import Banking from "./components/subroute/Banking/Banking";
import Payment from "./components/subroute/Payment/Payment";
import Travel from "./components/subroute/Travel/Travel";
import Recharge from "./components/subroute/Recharge/Recharge";
import FFP from "./components/subroute/Others/FFP/FFP";
import ProductsAndServices from "./components/subroute/ProductsAndServices/ProductsAndServices";
import LocateAgents from "./components/subroute/Others/LocateAgents/LocateAgents";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/spice-money-faq",
      name: "faq",
      component: FAQ
    },
    {
      path: "/spice-money-privacyPolicy",
      name: "privacyPolicy",
      component: PrivacyPolicy
    },
    {
      path: "/spice-money-tnc",
      name: "termsAndCondition",
      component: TNC
    },
    {
      path: "/spice-money-scheduleofCharges",
      name: "scheduleofCharges",
      component: SOC
    },
    {
      path: "/spice-money-agents",
      name: "locateAgents",
      component: LocateAgents
    },
    {
      path: "/spice-money-ffp",
      name: "ffp",
      component: FFP
    },

    {
      path: "/spice-money-customerGrievance",
      name: "customerGrievance",
      component: CustomerGrievance
    },
    {
      path: "/spice-money-about",
      name: "about",
      component: About
    },
    {
      path: "/spice-money-products",
      name: "products",
      component: ProductsAndServices
    },
    // {
    //   path: "/spice-money-team",
    //   name: "team",
    //   component: OurTeam
    // },
    {
      path: "/spice-money-partners",
      name: "partners",
      component: Partners
    },
    {
      path: "/",
      name: "explore",
      component: Explore
    },
    {
      path: "/spice-money-banking",
      name: "banking",
      component: Banking
    },
    {
      path: "/spice-money-payment",
      name: "payment",
      component: Payment
    },
    {
      path: "/spice-money-travel",
      name: "travel",
      component: Travel
    },
    {
      path: "/spice-money-recharge",
      name: "recharge",
      component: Recharge
    },

    {
      path: "/spice-money-joinNow",
      name: "joinNow",
      component: JoinNow
    },
    {
      path: "/spice-money-ourJourney",
      name: "ourJourney",
      component: OurJourney
    },
    {
      path: "/spice-money-career",
      name: "career",
      component: Career
    },
    {
      path: "/spice-money-contact",
      name: "contact",
      component: Contact
    },

    {
      path: "/pageNotFound",
      name: "pagenotFound",
      component: PageNotFound
    },

    {
      path: "*",
      redirect: "/pageNotFound"
    }
  ]
});

export default router;
